let lsEntries = Object.entries(localStorage);

export const setDefaults = () => {

        const addDefaultSources = () => {
            localStorage.setItem("guardian", "true");
            document.getElementById("guardian").checked = true;
            localStorage.setItem("marketWatch", "true");
            document.getElementById("marketWatch").checked = true;
            localStorage.setItem("foxNews", "true");
            document.getElementById("foxNews").checked = true;

            localStorage.setItem('alternet', 'false');
            document.getElementById("alternet").checked = false;
            localStorage.setItem('techCrunch', 'false');
            localStorage.setItem('wired', 'false');
            document.getElementById("wired").checked = false;
            localStorage.setItem('techCrunch', 'false');
            document.getElementById("techCrunch").checked = false;
            localStorage.setItem('independent', 'false');
            document.getElementById("independent").checked = false;
            localStorage.setItem('nyTimes', 'false');
            document.getElementById("nyTimes").checked = false;
            localStorage.setItem('seekingAlpha', 'false');
            document.getElementById("seekingAlpha").checked = false;
            localStorage.setItem('forbes', 'false');
            document.getElementById("forbes").checked = false;
            localStorage.setItem('hackerNews', 'false');
            document.getElementById("hackerNews").checked = false;
            localStorage.setItem('cnn', 'false');
            document.getElementById("cnn").checked = false;
            localStorage.setItem('time', 'false');
            document.getElementById("time").checked = false;
            localStorage.setItem('bbc', 'false');
            document.getElementById("bbc").checked = false;
            localStorage.setItem('politico', 'false');
            document.getElementById("politico").checked = false;
            localStorage.setItem('nbc', 'false');
            document.getElementById("nbc").checked = false;
            localStorage.setItem('dailyMail', 'false');
            document.getElementById("dailyMail").checked = false;
            localStorage.setItem('nationalReview', 'false');
            document.getElementById("nationalReview").checked = false;
    }
    const addDefaultBias = () => {
        localStorage.setItem('alternetBias', 'left');
        document.getElementById("alternetL").checked = true;

        localStorage.setItem('hackerNewsBias', 'left');
        document.getElementById("hackerNewsL").checked = true;
        localStorage.setItem('techCrunchBias', 'left');
        document.getElementById("techCrunchL").checked = true;
        localStorage.setItem('wiredBias', 'left');
        document.getElementById("wiredL").checked = true;
        localStorage.setItem('cnnBias', 'left');
        document.getElementById("cnnL").checked = true;
        localStorage.setItem('guardianBias', 'left');
        document.getElementById("guardianL").checked = true;
        localStorage.setItem('independentBias', 'left');
        document.getElementById("independentL").checked = true;
        localStorage.setItem('nyTimesBias', 'left');
        document.getElementById("nyTimesL").checked = true;
        localStorage.setItem('timeBias', 'left');
        document.getElementById("timeL").checked = true;

        localStorage.setItem('marketWatchBias', 'center');
        document.getElementById("marketWatchC").checked = true;
        localStorage.setItem('forbesBias', 'center');
        document.getElementById("forbesC").checked = true;
        localStorage.setItem('bbcBias', 'center');
        document.getElementById("bbcC").checked = true;
        localStorage.setItem('politicoBias', 'center');
        document.getElementById("politicoC").checked = true;
        localStorage.setItem('nbcBias', 'center');
        document.getElementById("nbcC").checked = true;

        localStorage.setItem('seekingAlphaBias', 'center');
        document.getElementById("seekingAlphaR").checked = true;
        localStorage.setItem('dailyMailBias', 'right');
        document.getElementById("dailyMailR").checked = true;
        localStorage.setItem('nationalReviewBias', 'right');
        document.getElementById("nationalReviewR").checked = true;
        localStorage.setItem('foxNewsBias', 'right');
        document.getElementById("foxNewsR").checked = true;


    }

    if (localStorage.guardian === undefined) {
        addDefaultSources()
    }

    let localStorageBiasMatches = []
    for (let i of lsEntries) {
        if (i[0].match(/Bias/)) {
            localStorageBiasMatches.push(i[0])
        }
    }
    if (localStorageBiasMatches.length === 0) {
        addDefaultBias()
    }
}